import {WorkspaceSingleRunQuery} from '../../../generated/graphql';
import {getRunState, parseConfig} from '../../../util/runs';
import {KeyVal, Run} from '../../../util/runTypes';

export type SingleRunModeRun = {
  id: string;
  name: string;
  createdAt: string;
  displayName: string;
  defaultColorIndex?: number;
  state: string;
  _wandb: KeyVal;
};

/**
 * Converts WorkspaceSingleRun query data to SingleRunModeRun type expected by the context
 */
export function mapQueryDataToRun(
  data: WorkspaceSingleRunQuery | undefined
): SingleRunModeRun | undefined {
  const raw = data?.project?.run;
  if (!raw) {
    return undefined;
  }

  const {_wandb = {}} = parseConfig(raw.config, raw.name) ?? {};
  return {
    id: raw.id,
    name: raw.name,
    createdAt: raw.createdAt,
    displayName: raw.displayName ?? raw.name,
    defaultColorIndex: raw.defaultColorIndex ?? undefined,
    state: getRunState(raw.state),
    _wandb,
  };
}

/**
 * Converts run object from RunWorkspaceRunContext to the slimmed down SingleRunModeRun type.
 * Eventually RunWorkspaceRunContext will be removed and so will this function.
 */
export function mapDeprecatedRun(
  run: Run | null
): SingleRunModeRun | undefined {
  if (!run) {
    return undefined;
  }
  return {
    id: run.id,
    name: run.name,
    createdAt: run.createdAt,
    displayName: run.displayName,
    defaultColorIndex: run.defaultColorIndex ?? undefined,
    state: run.state,
    _wandb: run._wandb,
  };
}
